import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputPhoneInternationalComponent } from './input-phone-international/input-phone-international.component';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';



@NgModule({
  declarations: [
    InputPhoneInternationalComponent
  ],
  exports: [
    InputPhoneInternationalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    LazyLoadImageModule
  ]
})
export class InputPhoneInternationalModule { }
